import type { IDiagnosticReportGetOne } from '../../interfaces/diagnosticReportGetOne';
import { translateKey } from '../../../translate';
import { Button } from '../common';

interface ISendClarificationButtonProps {
    diagnosticReport: IDiagnosticReportGetOne;
    isDisabled: boolean;
    sendClarification: () => Promise<void>;
}

export function SendClarificationButton(props: ISendClarificationButtonProps) {
    if (
        !props.diagnosticReport.authorization ||
        (!props.diagnosticReport.authorization.canAddDiagnosticReportClarificationRequester &&
            !props.diagnosticReport.authorization.canAddDiagnosticReportClarificationPerformer)
    ) {
        return null;
    }

    return (
        <Button
            automation="sendClarification"
            color="secondary"
            disabled={props.isDisabled}
            large
            onClick={props.sendClarification}
        >
            {props.diagnosticReport.authorization.canAddDiagnosticReportClarificationRequester
                ? translateKey('diagnosticReport.saveClarification')
                : translateKey('diagnosticReport.saveClarificationReaction')}
        </Button>
    );
}
